<template>
  <div class="public-beta-panel">
    <div class="gap-row-1xs w-100">
      <div class="title">
        <div class="qrw-heading-xs bold qrw-text-content-base-primary">{{ $t('public_beta.title') }}</div>
        <BaseLabelBadge
          variant="filled"
          size="xs"
          primaryColor="background-base-primary"
          secondaryColor="content-error-primary"
        >
          Public Beta</BaseLabelBadge>
      </div>
      <div class="qrw-paragraph-md qrw-text-content-base-secondary">
        {{ $t('public_beta.desc') }}
      </div>
      <div class="qrw-paragraph-md qrw-text-content-base-secondary">
        {{ $t('public_beta.supported_in') }} INSIDE, TAKEAWAY, DELIVERY
      </div>
    </div>
    <IQOSToggle
      v-model="fields.use_inside_superapp"
      size="lg"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: {},

      loaded: false
    }
  },
  watch: {
    fields: {
      handler() {
        if (!this.loaded) return

        this.$store.commit('patchCafeGeneralData', {
          ui_settings: this.fields
        })
        this.$store.dispatch('saveCafe')
      },
      deep: true
    }
  },
  mounted() {
    this.fields = this.cafe.ui_settings

    this.loaded = true
  },
  computed: {
    cafe() {
      return this.$store.state.cafe
    }
  }
}
</script>

<style scoped>
.public-beta-panel {
  display: flex;
  background: var(--qrw-background-base-primary-10);
  column-gap: 16px;
  padding: 12px 16px;
  box-shadow: var(--qrw-shadow-card-light);
  border-radius: 12px;
  align-items: flex-start;
}

.title {
  display: flex;
  column-gap: 4px;
  align-items: flex-start;
  padding: 2px 0;
}
</style>
